import { render, staticRenderFns } from "./wxxiangqingCreate.vue?vue&type=template&id=04449679&scoped=true"
import script from "./wxxiangqingCreate.vue?vue&type=script&lang=js"
export * from "./wxxiangqingCreate.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingCreate.vue?vue&type=style&index=0&id=04449679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04449679",
  null
  
)

export default component.exports